import dynamic from 'next/dynamic';

export const MessageCDynamicDeny = dynamic(() => import('./deny'), {
	ssr: false,
});

export const MessageCDynamicConfirm = dynamic(() => import('./confirm'), {
	ssr: false,
});

export default { MessageCDynamicDeny, MessageCDynamicConfirm };
